import React from 'react';
import { CheckCircleIcon } from '@fronton/icons-react';

export const SNACKS = {
  SUCCESS_TOKEN_COPY: {
    title: 'Токен скопирован',
    icon: <CheckCircleIcon size="l" />,
    type: 'success',
    time: true,
  },
};
